export default "__VITE_ASSET__535f8c86__"